var STRINGS = {
 es:
 {
  tests:{
    "1": "Sim operativa",
    "3": "Sim - Clave",
    "5": "Versión de S.O.",
    "11": "Wi-Fi Conectado",
    "12": "Wi-Fi IP",
    "13": "Wi-Fi Retrasos",
    "14": "Wi-Fi Pérdida paquetes",
    "15": "Wi-Fi Velocidad bajada",
    "16": "Wi-Fi Velocidad Subida",
    "17": "Comprobación APN",
    "18": "Datos Móviles Activados",
    "19": "Datos Móviles Conectados",
    "20": "Móvil IP",
    "21": "Datos Móviles - Retrasos",
    "22": "Datos Móviles - Pérdida paquetes",
    "23": "Datos Móviles - Velocidad bajada",
    "24": "Datos Móviles - Velocidad subida",
    "25": "Bluetooth Disponible",
    "33": "Pixels rotos",
    "35": "Limpiar Pantalla",
    "36": "Toque múltiple",
    "38": "Vibración",
    "39": "USB Conector",
    "50": "Imagen de cámara",
    "52": "Salud de Batería",
    "67": "Altavoz",
    "68": "Micrófono",
    "69": "Auricular",
    "70": "Servicio de Red",
    "71": "Señal de red",
    "72": "CPU Carga",
    "74": "RAM Carga",
    "75": "Memoria interna",
    "76": "Memoria externa",
    "77": "Comprobar 'rooteado' ",
    "79": "Tipo de Red móvil",
    "80": "Sensor de orientación",
    "81": "Luz de Flash",
    "82": "Capacidad de batería",
    "83": "Temperatura de batería",
    "84": "Brillo de pantalla",
    "85": "Timeout de pantalla",
    "86": "Apps en ejecución",
    "87": "Conexiones activas",
    "113": "GPS",
    "116": "Limpiador del dispositivo",
    "115": "Analizador de Malware",
    "117": "Localizador de dispositivo",
    "118": "Sonido de alerta",
    "test_id": 119,
    "119": "Cerrar dispositivo",
    "120": "Borrar dispostivo",
    "121": "Tomar imagen en silencio",
    "122": "Captura de pantalla",
    "123": "Gestión de paquetes",
    "124": "Operador de red",
    "125": "Funcionalidades remotas",
    "126": "Fuentes desconocidas",
    "127": "Verificación de apps",
    "128": "Contraseña visible",
    "129": "MDMActivado",
    "133": "Modo de vuelo",
    "159": "Cargador de batería",
    "100": "Cámara frontal"
 },
 groups: {
    "1": "Grupo de Test SIM",
    "2": "Grupo de Test Software",
    "3": "Grupo de Test Red",
    "5": "Grupo de Test Hardware",
    "12": "Grupo de Test Batería"
 },
 evaluations: {
    "0": "Desestimado",
    "1": "Resulado no posible",
    "2": "OK",
    "3": "Alerta",
    "4": "Problema",
    "5": "Error de configuración",
    "6": "Faltan Pre-requisitos"
  },
   device_details_Battery:"Battery Level",
  speed_test_units_mbps:"Mbit/s",
  speed_test_no_data:"No readings are available",
  speed_test_target_str:"Target",
  speed_test_source_str:"Source",
  speed_test_network_type_prefix:"Result for",
  speed_test_title:"Speed Test",
  speed_test_tab_title:"Results",
  id_speed_test_download:"Download",
  id_speed_test_upload:"Upload",
  speed_test_date_label:"Date",
  speed_test_server_label:"Server :",
  speed_test_distance_label:"Distance :",
  speed_test_slider_label:"Provider Line Speed (MBit/s) : ",
  st_network_type_all:"all networks",
  speed_test_type_wifi:"WiFi Speed",
  speed_test_type_provider:"Provider speed",
  speed_test_type_total:"Total speed",
  id_test_again:"TEST AGAIN",
  speed_test_graph_yaxis_label:"Speed",
  speed_test_graph_xaxis_label:"Time",
  speed_test_unknown_network:"unknown network",
  device_offline_status_logout:"This device appears to be offline. Consider waking up the device before making a call",
  device_offline_status_connectionlost:"Could not get through to the client. Check device status and internet connection",
  device_offline_status_terminated:"Call dropped. Check device status and internet connection",
  call_noresponse_status_ongoing:"The call has ended unexpectedly. Check device status and internet connection",
  call_noresponse_status_logout:"Could not connect. The user has logged out of the application",
  call_noresponse_status_connectionlost:"Call dropped. Check connection quality",
  call_noresponse_status_terminated:"The call has ended unexpectedly. Check device status and internet connection",
  unknown_router_type:"unknown router",
  NotAllowedError:"This software could not access your camera/microphone. Please allow access by clicking video/audio icon next to the address bar",
  PermissionDeniedError:"You denied access to camera/microphone. Please allow access by clicking video/audio icon next to the address bar",
  NotFoundError:"Could not detect the camera/microphone on this device",
  DevicesNotFoundError:"Camera/microphone not found",
  NotReadableError:"Could not read the data stream from camera/microphone.Restart your browser and try again",
  TrackStartError:"Camera/microphone could not be initiated. Restart your browser and try again",
  OverconstrainedError:"Camera/microphone failed",
  ConstraintNotSatisfiedError:"Camera/microphone missing",
  TypeError:"Camera/microphone failed to launch",
  DetectionFail:"Failed to detect camera/microphone.",
  DeviceInfo:"Información de dispositivo",
  Diagnosticresult:"Resultado de Diagnóstico: ",
  Diagnosticrequest:"Solicitud de diagnóstico: ",
  installApp:"InstallarApp",
  uninstallApp:"DesinstalarApp",
  Securitypolicies:"Políticas de seguridad",
  loading:"Loading...",
  Diagnostic_fix_request:"Solicitud de cambio de configuración: ",
  RemoteScreenshot:"CapturaDePantalla",
  result_list_section_title_OK:"All Good",
  result_list_section_title_Warning:"Identified Warning",
  result_list_section_title_Warnings:"Identified Warnings",
  result_list_section_title_Ignored:"Ignored",
  result_list_manual_tests:"Manual tests",
  result_list_manual_test:"Manual test",
  result_list_in_progress:"In progress",
  no_history_found:"No history available",
  history_time_desc_periodic:"{timestamp_first} - {timestamp_last}",
  history_time_desc:"{timestamp_first} - {timestamp_last}({iterations} runs)",
  result_list_no_test_result_found:"No test result available",
  result_list_history:"History",
  result_list_details:"Details",
  result_list_about:"About",
  result_list_section_title_Problem:"Identified Problem",
  result_list_section_title_Problems:"Identified Problems",
  main_single_warning_multiple_components:"Warning detected",
  main_tap_to_expand:"Tap to expand",
  main_all_good:"All seems good",
  main_no_problems:"No problems found",
  test_result_header_device:"Device",
  test_result_header_base_station:"Mobile Base Station",
  test_result_header_internet:"Internet",
  test_result_header_wifi_router:"WiFi Router",
  test_result_header_wifi_network:"WiFi Network",
  test_result_header_fixed_line:"Fixed Line Network",
  test_result_header_mobile_network:"Mobile Network",
  test_result_header_mobile_backbone:"Mobile Backbone",
  ok_btn:"OK",
  result_history_Warning:"Warning",
  result_history_Problem:"Problem",
  result_list_settings:"Settings",
  trace_route:"Visual Trace Route",
  settings_time_unit_milliseconds_short:"ms.",
  trace_route_list_distance:"for {distance} km",
  trace_route_list_to_ip:"to {ip}",
  trace_route_map_gateway:"your gateway",
  trace_route_internal_hop:"internal hop",
  trace_route_invisible_hop:"Anonymous hop",
  no_data_available:"No data available",
  trace_route_summary_multiple_slowest_hops:"Multiple slowest hops with {max_latency} ms at {hop_positions}",
  trace_route_summary_single_slowest_hop:"Slowest hop {max_latency} ms between {hop1} and {hop2}",
  trace_route_summary:"{total_hops} hops traveling {distance} km in {latency} ms.",
  trace_route_your_device_loc:"your device - {device_ip}",
  trace_route_failure_summary:"Failed to reach {endpoint_name}. Tracing terminated on hop {hop_number}. The host has refused the connection.",
  trace_route_summary_your_device:"Your Device",
  trace_route_not_reached:" could not be reached.",
  trace_route_summary_no_distance:"{total_hops} hops traveling in {latency} ms.",
  add_destination:"Add Destination",
  trace_route_fetch_location:"Calculating current location..",
  trace_route_takes_some_time:"This will take a few seconds..",
  trace_route_Warning:"Warning",
  trace_route_valid_hostname:"Please enter a valid hostname or IP address",
  drawing_visual_route:"Marking visual route",
  test_result_more_btn:"MORE",
  test_result_fix_btn:"FIX",
  test_result_help_btn:"HELP ME",
  wifi_spectrum:"WiFi Channel Scan",
  wifi_channel_tab_graph:"Graph",
  wifi_channel_tab_networks:"Networks",
  wifi_spectrum_txt_recommended_channel:"Recommended channel",
  wifi_spectrum_txt_other_channels:"Other channels",
  wifi_spectrum_txt_curr_channel:"Current WiFi channel {channel} in {band}",
  id_switch_channel_confimation_desc:"Your router will restart. This may take up to three minutes.",
  id_switch_channel_busy:"Switching to WiFi channel {channel}",
  network_list_ssid:"SSID",
  network_list_bssid:"BSSID",
  wifi_network_list_channel:"Channel",
  wifi_network_list_band:"Band",
  id_busy_screen_desc:"this will take some seconds..",
  id_fix_done_titile:"Well done!",
  id_fix_failed_title:"Failed",
  id_btn_finish:"FINISH",
  wifi_help_unknown_router:"We could not identify the router. Please switch the channel manually from the router's web interface",
  wifi_help_router_test_progress:"Checking your router. Please try again later",
  wifi_help_router_not_configured:"Channel switch is not possible until the router is fully accessible. Apply the fix in the 'Router Login Status' test and re-attempt switching channels.",
  wifi_manual_switch_title:"Select a WiFi Channel to Switch",
  wifi_manual_switch_desc:"Please select your desired WiFi channel under the appropriate network bandwidth",
  wifi_channel_selection_dd_label_band:"WiFi Network Bandwidth",
  wifi_channel_selection_dd_label_channel:"WiFi Channel",
  wifi_spectrum_btn_switch_to_other_channel:"Manual",
  wifi_spectrum_good_btn_manual:"Manual",
  wifi_spectrum_good_btn_ok:"OK",
  wifi_spectrum_not_good_btn_manual:"Manual",
  wifi_spectrum_not_good_btn_fix:"FIX",
  wifi_spectrum_btn_get_tip:"GET A TIP",
  wifi_spectrum_btn_get_tip_desc_header:"Here you can find more tips for a good WiFi signal:",
  wifi_spectrum_btn_get_tip_desc_ins_one:"Turn your modem off and restart.",
  wifi_spectrum_btn_get_tip_desc_ins_two:"Reduce the distance between your modem and your mobile or tablet.",
  wifi_spectrum_btn_get_tip_desc_ins_three:"Remember that obstacles (e.g. doors, windows and walls) between your modem and your mobile or tablet will have an affect on your signal.",
  wifi_spectrum_btn_get_tip_desc_ins_four:"Change to a channel with less congestion. The best channel can change over time, so you may have to change channel several times",
  wifi_channel_graph_header_24ghz:"2.4 GHz range",
  wifi_channel_graph_header_5ghz:"5 GHz range",
  device_status_online:"Online",
  device_status_slow_res:"This device is responding slowly",
  device_status_very_slow_res:"This device is not responding",
  device_status_offline:"Offline",
  device_status_connected_nw:"Connected to your network",
  device_status_connected_quality:"Connection quality is below average",
  device_status_unstable_connection:"Unstable connection to the device",
  device_status_not_connected:"Not currently connected to your network",
  unknown_state:"Unknown",
  id_run_test:"RUN TEST",
  local_network_details_status:"Status",
  local_network_details_device_name:"Device name",
  local_network_tap_to_change:"Tap to change",
  local_network_details_type:"Type",
  local_network_details_connection:"Connection",
  local_network_tap_to_select:"Tap to select",
  local_network_details_last_seen:"Last seen",
  local_network_details_monitor_device:"Notifications",
  monitor_device_on:"ON",
  monitor_device_off:"OFF",
  local_network_details_mac:"MAC Address",
  local_network_details_ip:"IP Address",
  local_network_details_manufacturer:"Manufacturer",
  device_details_model:"Model",
  id_foreground:"Foreground App",
  id_battery_level:"Battery Level",
  local_network_details_responsiveness:"Responsiveness",
  device_details_conn_qual:"Connection Quality",
  device_details_cpu_usage:"CPU Usage",
  device_details_internet_usage:"Internet Usage",
  device_details_internet_usage_time:"(over last minute)",
  id_speed_test:"Speed Test",
  id_speed_test_p2p_desc:"Run Speed Test to this device",
  tap_entry:"Tap an entry to show details.",
  local_network_no_devices_found:"No Devices Found",
  device_type_gateway:"Gateway",
  device_type_access_point:"Access Point",
  device_type_printer:"Printer",
  device_type_media_server:"Media Server",
  device_type_tv_receiver:"TV Receiver",
  device_type_computer:"Computer",
  device_type_gaming_console:"Gaming Console",
  device_type_mobile:"Mobile",
  device_type_phone:"Phone",
  device_type_tablet:"Tablet",
  device_type_laptop:"Laptop",
  device_type_desktop:"Desktop",
  lan_devices:"Local Network Devices",
  device_details:"Device Details",
  diagnose_btn:"DIAGNOSE",
  result_list_execute:"EXECUTE",
  main_wifi_router_short:"Router",
  main_fixed_line_short:"Fixed line",
  main_wifi_network_short:"WiFi",
  str_waiting:"Waiting",
  str_supportqueue_is_empty:"Support queue is empty",
  str_signinto_agent_portal:"Sign In to your support agent panel",
  str_username_is_required:"Username is required",
  str_password_required:"Password is required",
  str_remember_me:"Remember me",
  str_signin:"Sign In",
  str_cred_incorrect:"Username and/or Password are incorrect",
  str_server_unavailble:"Server not reachable. Please try again in a few minutes.",
  str_forgot_pwd:"Forgot password?",
  str_create_new_account:"Create a new account",
  str_enter_email_to_recover:"Enter your email address to recover your password.",
  str_email_required:"Email is required",
  str_invalid_email:"That's not a valid email",
  str_reset_pwd:"Reset Password",
  str_backto_login:"Back to Login",
  str_create_account:"Create an account",
  str_repeat_password:"Repeat password is required",
  str_agree_with:" I agree with the ",
  str_terms_conditions:"Terms and Conditions",
  str_sign_up:"Sign Up",
  str_user_email_already_registered:"Username and/or email are already registered",
  str_have_account:"Already have an account? ",
  str_enter_pwd_to_unlock:"Please enter your password to unlock the screen!",
  str_login:"Login In",
  str_sign_other_account:"Sign in using different account",
  str_profile:"Profile",
  str_first_name:"First name",
  str_last_name:"Last name",
  str_email:"Email",
  str_mobile_number:"Mobile number",
  str_lock:"Lock",
  str_logout:"Logout",
  str_menu:"Menu",
  str_dashboard:"Dashboard",
  str_digital_support:"Digital Support",
  str_data_analytics:"Data Analytics",
  str_marketing_engine:"Marketing Engine",
  str_registered_users:"Registered Users",
  str_support_cases:"Support Cases",
  str_diagnostic_tests:"Diagnostic Tests",
  str_usage_activity:"Usage Activity",
  str_users:"Users",
  str_devices:"Devices",
  str_sessions:"Sessions",
  str_info_from_ndays:"Information displayed is data from last 90 days.",
  str_device_share:"Device Share",
  str_support_center:"Support Center",
  str_search:"Search",
  str_create_user:"Create user",
  str_wakedevice:"Wake Device",
  str_device:"Device",
  str_live_diagnostics_results:"Live diagnostics results",
  str_provider:"Current Provider",
  str_publicip:"Public IP",
  str_ticket:"Ticket",
  str_status:"Status",
  str_assigned:"Assigned",
  str_new_ticket:"New Ticket",
  str_timeline_box:"Timeline",
  str_running_tests:"Running tests..",
  str_cancel:"CANCEL",
  str_wifi_configuration:"Wifi configuration",
  str_custom_user_settings:"Custom User Settings",
  str_speedtest_header:"Run Internet Speed Test on this device",
  str_ida_host:"Ida Host",
  str_test_group:"Test group",
  str_run:"Run",
  str_test:"Test",
  str_silently:"Silently",
  str_customer_details:"Customer details",
  str_contract_plan:"Contract plan",
  str_no_info_available:"No information available",
  str_model:"Model",
  str_device_offline:"Device is offline",
  str_ringing:"Ringing",
  str_no_av_device_pc:"No video/audio device found on your PC",
  str_check_av_input:"Please check audio/video input",
  str_call_accept_by:"Call accepted by ",
  str_agent_closes_call:"Support Agent has closed the call",
  str_incoming_call:"Incoming call",
  str_call_cancel_timeout:"Call rejected after 30 secs",
  str_call_accepted:"Call accepted",
  str_agent_cancel_call:"Support has cancelled the call",
  str_in_video_call:"You are in video call",
  str_close:"Close",
  str_connect:"Connect",
  str_disconnect:"Disconnect",
  str_remote_timeout:"Request will be timed out in",
  str_canvas_not_supported:"Canvas not supported.",
  str_input_mode:"Input mode",
  str_event_injection:"Event Injection",
  str_screen_drawing:"Screen Drawing",
  str_quick_access_screens:"Quick access screens",
  str_settings:"Settings",
  str_battery:"Battery",
  str_security:"Security",
  str_apps:"Apps",
  str_status_notavailable:"Status not available",
  router_dialog_content:"Please enter router password to begin diagnostics:",
  router_dialog_username:"Username",
  router_dialog_pwd:"Password",
  router_dialog_validation_username_required:"Username required",
  router_dialog_validation_pwd_required:"Password required",
  cancel_btn:"CANCEL",
  str_agent_feedback:"Support Agent Feedback",
  str_thank_feedback:"Thank you for your feedback. It will help us to improve the agent.",
  str_feedback_user_complaint:"What did the user complain about?",
  str_feedback_complaint_slow:"Internet too slow",
  str_feedback_complaint_not_work:"Internet not working",
  str_feedback_complaint_trouble:"Device making trouble",
  str_other:"Other",
  str_feedback_problem_identify:"Could you identify the root cause of the problem?",
  str_feedback_problem_cause:"If yes, What was the cause?",
  str_feedback_problem_solve:"Could you solve the problem?",
  str_yes:"Yes",
  str_no:"NO",
  str_feedback_app_helpful:"Was the mobile app helpful in solving the problem?",
  str_feedback_total_helpful:"totall not helpful",
  str_feedback_vhelpful:"very helpful",
  str_feedback_customer_satisfaction:"How happy was the customer with the solution? ",
  str_feedback_not_happy:"totall not happy",
  str_feedback_vhappy:"very happy",
  str_submit:"SUBMIT",
  str_skipform:"Skip form",
  str_close_ticket:"Close Ticket",
  str_speedtest_fail_status:"Speed test request has been failed due to following error:",
  str_try_again:"Please try again",
  str_speedtest_error_msg:"The request timed out. Please check whether the device is online.",
  str_remote_fail_status:"Remote session has been failed due to following error:",
  str_videocall_fail_status:"Video calling has been failed",
  str_remote_running_status:"Remote session has been running with",
  str_remote_restart_msg:"Please disconnect and proceed",
  str_session_expired:"Your session has expired",
  str_plz_login:"Please login again.",
  str_continue:"Continue",
  str_no_open_conversation:"User does not have any open conversations",
  str_want_2_create_ticket:"Do you want to create a new one?",
  str_connecting_server:"Connecting to server..",
  speed_test_data_consumption_warning:"Running a speed test requires sending and receiving data and is best done on connections with no usage limit. It is advised to refrain from testing on mobile data connections.",
  get_logs_btn:"GET LOGS",
  str_send:"Send",
  str_request_access:"Request access",
  str_issues_found:"Issues found"
 },
 en:
 {
  device_details_Battery:"Battery Level",
  speed_test_units_mbps:"Mbit/s",
  speed_test_no_data:"No readings are available",
  speed_test_target_str:"Target",
  speed_test_source_str:"Source",
  speed_test_network_type_prefix:"Result for",
  speed_test_title:"Speed Test",
  speed_test_tab_title:"Results",
  id_speed_test_download:"Download",
  id_speed_test_upload:"Upload",
  speed_test_date_label:"Date",
  speed_test_server_label:"Server :",
  speed_test_distance_label:"Distance :",
  speed_test_slider_label:"Provider Line Speed (MBit/s) : ",
  st_network_type_all:"all networks",
  speed_test_type_wifi:"WiFi Speed",
  speed_test_type_provider:"Provider speed",
  speed_test_type_total:"Total speed",
  id_test_again:"TEST AGAIN",
  speed_test_graph_yaxis_label:"Speed",
  speed_test_graph_xaxis_label:"Time",
  speed_test_unknown_network:"unknown network",
  device_offline_status_logout:"This device appears to be offline. Consider waking up the device before making a call",
  device_offline_status_connectionlost:"Could not get through to the client. Check device status and internet connection",
  device_offline_status_terminated:"Call dropped. Check device status and internet connection",
  call_noresponse_status_ongoing:"The call has ended unexpectedly. Check device status and internet connection",
  call_noresponse_status_logout:"Could not connect. The user has logged out of the application",
  call_noresponse_status_connectionlost:"Call dropped. Check connection quality",
  call_noresponse_status_terminated:"The call has ended unexpectedly. Check device status and internet connection",
  unknown_router_type:"unknown router",
  NotAllowedError:"This software could not access your camera/microphone. Please allow access by clicking video/audio icon next to the address bar",
  PermissionDeniedError:"You denied access to camera/microphone. Please allow access by clicking video/audio icon next to the address bar",
  NotFoundError:"Could not detect the camera/microphone on this device",
  DevicesNotFoundError:"Camera/microphone not found",
  NotReadableError:"Could not read the data stream from camera/microphone.Restart your browser and try again",
  TrackStartError:"Camera/microphone could not be initiated. Restart your browser and try again",
  OverconstrainedError:"Camera/microphone failed",
  ConstraintNotSatisfiedError:"Camera/microphone missing",
  TypeError:"Camera/microphone failed to launch",
  DetectionFail:"Failed to detect camera/microphone.",
  Securitypolicies:"Security policies",
  DeviceInfo:"DeviceInfo",
  Diagnosticresult:"Diagnostic result: ",
  Diagnosticrequest:"Diagnostic request: ",
  installApp:"installApp",
  uninstallApp:"uninstallApp",
  loading:"Loading...",
  Diagnostic_fix_request:"Diagnostic fix request: ",
  str_wifi:"WiFi",
  str_line:"Line",
  str_internet_speed:"Internet Speed",
  RemoteScreenshot:"RemoteScreenshot",
  result_list_section_title_OK:"All Good",
  result_list_section_title_Warning:"Identified Warning",
  result_list_section_title_Warnings:"Identified Warnings",
  result_list_section_title_Ignored:"Ignored",
  result_list_manual_tests:"Manual tests",
  result_list_manual_test:"Manual test",
  result_list_in_progress:"In progress",
  no_history_found:"No history available",
  history_time_desc_periodic:"{timestamp_first} - {timestamp_last}",
  history_time_desc:"{timestamp_first} - {timestamp_last}({iterations} runs)",
  result_list_no_test_result_found:"No test result available",
  result_list_history:"History",
  result_list_details:"Details",
  result_list_about:"About",
  result_list_section_title_Problem:"Identified Problem",
  result_list_section_title_Problems:"Identified Problems",
  main_single_warning_multiple_components:"Warning detected",
  main_tap_to_expand:"Tap to expand",
  main_all_good:"All seems good",
  main_no_problems:"No problems found",
  test_result_header_device:"Device",
  test_result_header_base_station:"Mobile Base Station",
  test_result_header_internet:"Internet",
  test_result_header_wifi_router:"WiFi Router",
  test_result_header_wifi_network:"WiFi Network",
  test_result_header_fixed_line:"Fixed Line Network",
  test_result_header_mobile_network:"Mobile Network",
  test_result_header_mobile_backbone:"Mobile Backbone",
  ok_btn:"OK",
  result_history_Warning:"Warning",
  result_history_Problem:"Problem",
  result_list_settings:"Settings",
  trace_route:"Visual Trace Route",
  settings_time_unit_milliseconds_short:"ms.",
  trace_route_list_distance:"for {distance} km",
  trace_route_list_to_ip:"to {ip}",
  trace_route_map_gateway:"your gateway",
  trace_route_internal_hop:"internal hop",
  trace_route_invisible_hop:"Anonymous hop",
  no_data_available:"No data available",
  trace_route_summary_multiple_slowest_hops:"Multiple slowest hops with {max_latency} ms at {hop_positions}",
  trace_route_summary_single_slowest_hop:"Slowest hop {max_latency} ms between {hop1} and {hop2}",
  trace_route_summary:"{total_hops} hops traveling {distance} km in {latency} ms.",
  trace_route_your_device_loc:"your device - {device_ip}",
  trace_route_failure_summary:"Failed to reach {endpoint_name}. Tracing terminated on hop {hop_number}. The host has refused the connection.",
  trace_route_summary_your_device:"Your Device",
  trace_route_not_reached:" could not be reached.",
  trace_route_summary_no_distance:"{total_hops} hops traveling in {latency} ms.",
  add_destination:"Add Destination",
  trace_route_fetch_location:"Calculating current location..",
  trace_route_takes_some_time:"This will take a few seconds..",
  trace_route_Warning:"Warning",
  trace_route_valid_hostname:"Please enter a valid hostname or IP address",
  drawing_visual_route:"Marking visual route",
  test_result_more_btn:"MORE",
  test_result_fix_btn:"FIX",
  test_result_help_btn:"HELP ME",
  wifi_spectrum:"WiFi Channel Scan",
  wifi_channel_tab_graph:"Graph",
  wifi_channel_tab_networks:"Networks",
  wifi_spectrum_txt_recommended_channel:"Recommended channel",
  wifi_spectrum_txt_other_channels:"Other channels",
  wifi_spectrum_txt_curr_channel:"Current WiFi channel {channel} in {band}",
  id_switch_channel_confimation_desc:"Your router will restart. This may take up to three minutes.",
  id_switch_channel_busy:"Switching to WiFi channel {channel}",
  network_list_ssid:"SSID",
  network_list_bssid:"BSSID",
  wifi_network_list_channel:"Channel",
  wifi_network_list_band:"Band",
  id_busy_screen_desc:"this will take some seconds..",
  id_fix_done_titile:"Well done!",
  id_fix_failed_title:"Failed",
  id_btn_finish:"FINISH",
  wifi_help_unknown_router:"We could not identify the router. Please switch the channel manually from the router's web interface",
  wifi_help_router_test_progress:"Checking your router. Please try again later",
  wifi_help_router_not_configured:"Channel switch is not possible until the router is fully accessible. Apply the fix in the 'Router Login Status' test and re-attempt switching channels.",
  wifi_manual_switch_title:"Select a WiFi Channel to Switch",
  wifi_manual_switch_desc:"Please select your desired WiFi channel under the appropriate network bandwidth",
  wifi_channel_selection_dd_label_band:"WiFi Network Bandwidth",
  wifi_channel_selection_dd_label_channel:"WiFi Channel",
  wifi_spectrum_btn_switch_to_other_channel:"Manual",
  wifi_spectrum_good_btn_manual:"Manual",
  wifi_spectrum_good_btn_ok:"OK",
  wifi_spectrum_not_good_btn_manual:"Manual",
  wifi_spectrum_not_good_btn_fix:"FIX",
  wifi_spectrum_btn_get_tip:"GET A TIP",
  wifi_spectrum_btn_get_tip_desc_header:"Here you can find more tips for a good WiFi signal:",
  wifi_spectrum_btn_get_tip_desc_ins_one:"Turn your modem off and restart.",
  wifi_spectrum_btn_get_tip_desc_ins_two:"Reduce the distance between your modem and your mobile or tablet.",
  wifi_spectrum_btn_get_tip_desc_ins_three:"Remember that obstacles (e.g. doors, windows and walls) between your modem and your mobile or tablet will have an affect on your signal.",
  wifi_spectrum_btn_get_tip_desc_ins_four:"Change to a channel with less congestion. The best channel can change over time, so you may have to change channel several times",
  wifi_channel_graph_header_24ghz:"2.4 GHz range",
  wifi_channel_graph_header_5ghz:"5 GHz range",
  device_status_online:"Online",
  device_status_slow_res:"This device is responding slowly",
  device_status_very_slow_res:"This device is not responding",
  device_status_offline:"Offline",
  device_status_connected_nw:"Connected to your network",
  device_status_connected_quality:"Connection quality is below average",
  device_status_unstable_connection:"Unstable connection to the device",
  device_status_not_connected:"Not currently connected to your network",
  unknown_state:"Unknown",
  id_run_test:"RUN TEST",
  local_network_details_status:"Status",
  local_network_details_device_name:"Device name",
  local_network_tap_to_change:"Tap to change",
  local_network_details_type:"Type",
  local_network_details_connection:"Connection",
  local_network_tap_to_select:"Tap to select",
  local_network_details_last_seen:"Last seen",
  local_network_details_monitor_device:"Notifications",
  monitor_device_on:"ON",
  monitor_device_off:"OFF",
  local_network_details_mac:"MAC Address",
  local_network_details_ip:"IP Address",
  local_network_details_manufacturer:"Manufacturer",
  device_details_model:"Model",
  id_foreground:"Foreground App",
  id_battery_level:"Battery Level",
  local_network_details_responsiveness:"Responsiveness",
  device_details_conn_qual:"Connection Quality",
  device_details_cpu_usage:"CPU Usage",
  device_details_internet_usage:"Internet Usage",
  device_details_internet_usage_time:"(over last minute)",
  id_speed_test:"Speed Test",
  id_speed_test_p2p_desc:"Run Speed Test to this device",
  tap_entry:"Tap an entry to show details.",
  local_network_no_devices_found:"No Devices Found",
  device_type_gateway:"Gateway",
  device_type_access_point:"Access Point",
  device_type_printer:"Printer",
  device_type_media_server:"Media Server",
  device_type_tv_receiver:"TV Receiver",
  device_type_computer:"Computer",
  device_type_gaming_console:"Gaming Console",
  device_type_mobile:"Mobile",
  device_type_phone:"Phone",
  device_type_tablet:"Tablet",
  device_type_laptop:"Laptop",
  device_type_desktop:"Desktop",
  lan_devices:"Local Network Devices",
  device_details:"Device Details",
  diagnose_btn:"DIAGNOSE",
  result_list_execute:"EXECUTE",
  main_wifi_router_short:"Router",
  main_fixed_line_short:"Fixed line",
  main_wifi_network_short:"WiFi",
  str_waiting:"Waiting",
  str_supportqueue_is_empty:"Support queue is empty",
  str_signinto_agent_portal:"Sign In to your support agent panel",
  str_username_is_required:"Username is required",
  str_password_required:"Password is required",
  str_remember_me:"Remember me",
  str_signin:"Sign In",
  str_cred_incorrect:"Username and/or Password are incorrect",
  str_server_unavailble:"Server not reachable. Please try again in a few minutes.",
  str_forgot_pwd:"Forgot password?",
  str_create_new_account:"Create a new account",
  str_enter_email_to_recover:"Enter your email address to recover your password.",
  str_email_required:"Email is required",
  str_invalid_email:"That's not a valid email",
  str_reset_pwd:"Reset Password",
  str_backto_login:"Back to Login",
  str_create_account:"Create an account",
  str_repeat_password:"Repeat password is required",
  str_agree_with:" I agree with the ",
  str_terms_conditions:"Terms and Conditions",
  str_sign_up:"Sign Up",
  str_user_email_already_registered:"Username and/or email are already registered",
  str_have_account:"Already have an account? ",
  str_enter_pwd_to_unlock:"Please enter your password to unlock the screen!",
  str_login:"Login In",
  str_sign_other_account:"Sign in using different account",
  str_profile:"Profile",
  str_first_name:"First name",
  str_last_name:"Last name",
  str_email:"Email",
  str_mobile_number:"Mobile number",
  str_lock:"Lock",
  str_logout:"Logout",
  str_menu:"Menu",
  str_dashboard:"Dashboard",
  str_digital_support:"Digital Support",
  str_data_analytics:"Data Analytics",
  str_marketing_engine:"Marketing Engine",
  str_registered_users:"Registered Users",
  str_support_cases:"Support Cases",
  str_diagnostic_tests:"Diagnostic Tests",
  str_usage_activity:"Usage Activity",
  str_users:"Users",
  str_devices:"Devices",
  str_sessions:"Sessions",
  str_info_from_ndays:"Information displayed is data from last 90 days.",
  str_device_share:"Device Share",
  str_support_center:"Support Center",
  str_search:"Search",
  str_create_user:"Create user",
  str_wakedevice:"Wake Device",
  str_device:"Device",
  str_live_diagnostics_results:"Live diagnostics results",
  str_provider:"Current Provider",
  str_publicip:"Public IP",
  str_ticket:"Ticket",
  str_status:"Status",
  str_assigned:"Assigned",
  str_new_ticket:"New Ticket",
  str_timeline_box:"Timeline",
  str_running_tests:"Running tests..",
  str_cancel:"CANCEL",
  str_wifi_configuration:"Wifi configuration",
  str_custom_user_settings:"Custom User Settings",
  str_speedtest_header:"Run Internet Speed Test on this device",
  str_ida_host:"Ida Host",
  str_test_group:"Test group",
  str_run:"Run",
  str_test:"Test",
  str_silently:"Silently",
  str_customer_details:"Customer details",
  str_contract_plan:"Contract plan",
  str_no_info_available:"No information available",
  str_model:"Model",
  str_device_offline:"Device is offline",
  str_ringing:"Ringing",
  str_no_av_device_pc:"No video/audio device found on your PC",
  str_check_av_input:"Please check audio/video input",
  str_call_accept_by:"Call accepted by ",
  str_agent_closes_call:"Support Agent has closed the call",
  str_incoming_call:"Incoming call",
  str_call_cancel_timeout:"Call rejected after 30 secs",
  str_call_accepted:"Call accepted",
  str_agent_cancel_call:"Support has cancelled the call",
  str_in_video_call:"You are in video call",
  str_close:"Close",
  str_connect:"Connect",
  str_disconnect:"Disconnect",
  str_remote_timeout:"Request will be timed out in",
  str_canvas_not_supported:"Canvas not supported.",
  str_input_mode:"Input mode",
  str_event_injection:"Event Injection",
  str_screen_drawing:"Screen Drawing",
  str_quick_access_screens:"Quick access screens",
  str_settings:"Settings",
  str_battery:"Battery",
  str_security:"Security",
  str_apps:"Apps",
  str_status_notavailable:"Status not available",
  router_dialog_content:"Please enter router password to begin diagnostics:",
  router_dialog_username:"Username",
  router_dialog_pwd:"Password",
  router_dialog_validation_username_required:"Username required",
  router_dialog_validation_pwd_required:"Password required",
  cancel_btn:"CANCEL",
  str_agent_feedback:"Support Agent Feedback",
  str_thank_feedback:"Thank you for your feedback. It will help us to improve the agent.",
  str_feedback_user_complaint:"What did the user complain about?",
  str_feedback_complaint_slow:"Internet too slow",
  str_feedback_complaint_not_work:"Internet not working",
  str_feedback_complaint_trouble:"Device making trouble",
  str_other:"Other",
  str_feedback_problem_identify:"Could you identify the root cause of the problem?",
  str_feedback_problem_cause:"If yes, What was the cause?",
  str_feedback_problem_solve:"Could you solve the problem?",
  str_yes:"Yes",
  str_no:"NO",
  str_feedback_app_helpful:"Was the mobile app helpful in solving the problem?",
  str_feedback_total_helpful:"totall not helpful",
  str_feedback_vhelpful:"very helpful",
  str_feedback_customer_satisfaction:"How happy was the customer with the solution? ",
  str_feedback_not_happy:"totall not happy",
  str_feedback_vhappy:"very happy",
  str_submit:"SUBMIT",
  str_skipform:"Skip form",
  str_close_ticket:"Close Ticket",
  str_speedtest_fail_status:"Speed test request has been failed due to following error:",
  str_try_again:"Please try again",
  str_speedtest_error_msg:"The request timed out. Please check whether the device is online.",
  str_remote_fail_status:"Remote session has been failed due to following error:",
  str_videocall_fail_status:"Video calling has been failed",
  str_remote_running_status:"Remote session has been running with",
  str_remote_restart_msg:"Please disconnect and proceed",
  str_session_expired:"Your session has expired",
  str_plz_login:"Please login again.",
  str_continue:"Continue",
  str_no_open_conversation:"User does not have any open conversations",
  str_want_2_create_ticket:"Do you want to create a new one?",
  str_connecting_server:"Connecting to server..",
  speed_test_data_consumption_warning:"Running a speed test requires sending and receiving data and is best done on connections with no usage limit. It is advised to refrain from testing on mobile data connections.",
  get_logs_btn:"GET LOGS",
  str_send:"Send",
  str_request_access:"Request access",
  str_issues_found:"Issues found"
 },
 de: {
  "trace_route_takes_some_time": "Dies dauert einige Sekunden.",
  "add_destination": "Ziel hinzufügen",
  "trace_route_fetch_location": "Berechnung aktueller Standort ..",
  "trace_route_summary_no_distance": "{total_hops} hops in {latency} ms.",
  "trace_route_not_reached": "konnte nicht erreicht werden.",
  "trace_route_summary_your_device": "Ihr Gerät",
  "trace_route_failure_summary": "{endpoint_name} konnte nicht erreicht werden. Die Ablaufverfolgung wurde am Hop {hop_number} beendet. Der Host hat die Verbindung abgelehnt.",
  "trace_route_summary": "{total_hops} hops in {latency} ms für {distance} km.",
  "trace_route_internal_hop": "Interner Hop",
  "no_data_available": "Keine Daten verfügbar",
  "trace_route_list_to_ip": "zu {ip}",
  "trace_route": "Visual Traceroute",
  "settings_time_unit_milliseconds_short": "Frau",
  "result_history_Warning": "Warnung",
  "result_history_Problem": "Fehler",
  "result_list_settings": "Einstellungen",
  "ok_btn": "OK",
  "test_result_header_mobile_backbone": "Mobile Provider Backbone",
  "test_result_header_fixed_line": "Festnetz",
  "test_result_header_wifi_network": "WLAN",
  "test_result_header_base_station": "Mobilfunkantenne",
  "test_result_header_internet": "Internet",
  "test_result_header_wifi_router": "WLAN Router",
  "main_no_problems": "Keine Probleme gefunden",
  "main_all_good": "Alles OK",
  "main_tap_to_expand": "Mehr Info",
  "main_single_warning_multiple_components": "Warnung:",
  "result_list_section_title_Problem": "Fehler",
  "result_list_about": "Über",
  "result_list_no_test_result_found": "Kein Testergebnis verfügbar",
  "result_list_details": "Details",
  "history_time_desc": "{timestamp_first} - {timestamp_last} ({iterations} Iterationen)",
  "history_time_desc_periodic": "{timestamp_first} - {timestamp_last}",
  "result_list_section_title_Ignored": "Ignoriert",
  "result_list_manual_tests": "Manuelle Tests",
  "result_list_in_progress": "In Bearbeitung",
  "result_list_section_title_OK": "Alles gut",
  "uninstallApp": "App löschen",
  "loading": "Lädt...",
  "Diagnostic_fix_request": "Operation:",
  "str_wifi": "WLAN",
  "str_line": "Anschluß",
  "str_internet_speed": "Internet-Geschwindigkeit",
  "RemoteScreenshot": "RemoteScreenshot",
  "DeviceInfo": "Info Gerät",
  "Diagnosticresult": "Ergebnis: ",
  "Diagnosticrequest": "Anfrage: ",
  "installApp": "App installieren",
  "DetectionFail": "Kamera / Mikrofon wurde nicht erkannt.",
  "TrackStartError": "Kamera / Mikrofon konnte nicht gestartet werden. Starten Sie Ihren Browser neu und versuchen Sie es erneut",
  "Securitypolicies": "Sicherheitsrichtlinien",
  "OverconstrainedError": "Initialisierung Kamera / Mikrofon fehlgeschlagen",
  "ConstraintNotSatisfiedError": "Kamera / Mikrofon fehlt",
  "TypeError": "Kamera / Mikrofon konnte nicht gestartet werden",
  "DevicesNotFoundError": "Kamera / Mikrofon nicht gefunden",
  "NotReadableError": "Datenstrom von Kamera / Mikrofon konnte nicht gelesen werden. Starten Sie Ihren Browser neu und versuchen Sie es erneut",
  "PermissionDeniedError": "Sie haben den Zugriff auf Kamera / Mikrofon verweigert. Bitte erlauben Sie den Zugriff, indem Sie auf das Video- / Audio-Symbol neben der Adressleiste klicken",
  "NotFoundError": "Kamera / Mikrofon wurde auf diesem Gerät nicht erkannt",
  "unknown_router_type": "unbekannter Router",
  "call_noresponse_status_connectionlost": "Anruf unterbrochen. Schlechte Verbindung?",
  "call_noresponse_status_terminated": "Der Anruf wurde unerwartet beendet. Überprüfen Sie den Gerätestatus und die Internetverbindung",
  "call_noresponse_status_logout": "Konnte keine Verbindung herstellen. Der Benutzer hat sich von der Anwendung abgemeldet.",
  "call_noresponse_status_ongoing": "Der Anruf wurde unerwartet beendet. Überprüfen Sie den Gerätestatus und die Internetverbindung",
  "device_offline_status_terminated": "Anruf unterbrochen. Überprüfen Sie den Gerätestatus und die Internetverbindung",
  "speed_test_unknown_network": "unbekanntes Netzwerk",
  "speed_test_graph_xaxis_label": "Zeit",
  "id_test_again": "NOCHMAL",
  "speed_test_graph_yaxis_label": "Geschwindigkeit",
  "speed_test_type_provider": "Geschwindigkeit des Providers",
  "speed_test_type_p2p": "peer to peer speed",
  "speed_test_slider_label": "Provider Line Speed ​​(MBit/s):",
  "st_network_type_all": "Alle Netzwerke",
  "speed_test_server_label": "Server",
  "id_speed_test_upload": "Hochladen",
  "speed_test_date_label": "Datum",
  "id_speed_test_download": "Herunterladen",
  "speed_test_network_type_prefix": "Ergebnis für",
  "device_details_Battery": "Batterie Level",
  "speed_test_units_mbps": "Mbit/s",
  "speed_test_no_data": "Keine Messwerte",
  "speed_test_target_str": "Ziel",
  "speed_test_source_str": "Quelle",
  "trace_route_valid_hostname": "Bitte geben Sie einen gültigen Hostnamen oder eine gültige IP-Adresse ein",
  "trace_route_Warning": "Warnung",
  "drawing_visual_route": "Visual Route wird berechnet",
  "test_result_more_btn": "MEHR",
  "test_result_fix_btn": "FIX",
  "test_result_help_btn": "HILF MIR",
  "wifi_spectrum": "WLAN-Kanalscan",
  "wifi_channel_tab_networks": "Netzwerke",
  "wifi_spectrum_txt_recommended_channel": "Empfohlener Kanal",
  "wifi_spectrum_txt_other_channels": "Andere Kanäle",
  "wifi_spectrum_txt_curr_channel": "Aktueller WLAN-Kanal {channel} in {band}",
  "id_switch_channel_confimation_desc": "Ihr Router wird neu gestartet. Das kann einige Minuten dauern.",
  "id_switch_channel_busy": "Umschalten auf den WLAN-Kanal {channel}",
  "network_list_ssid": "SSID",
  "network_list_bssid": "BSSID",
  "wifi_network_list_channel": "Kanal",
  "wifi_network_list_band": "Band",
  "id_busy_screen_desc": "Dies dauert einige Sekunden ..",
  "id_fix_done_titile": "Erfolg",
  "id_btn_finish": "BEENDEN",
  "wifi_help_unknown_router": "Router konnte nicht identifiziert werden. Wechseln Sie den Kanal manuell über die Weboberfläche des Routers",
  "wifi_help_router_test_progress": "Verbindung zum Router wird hergestellt",
  "wifi_help_router_not_configured": "Der Kanalwechsel ist erst möglich, wenn die App sich am Router angemeldet hat. Wenden Sie das Update im \"\"Router Login Status\"\" -Test an, und versuchen Sie erneut, die Kanäle zu wechseln.",
  "wifi_manual_switch_desc": "Bitte wählen Sie Ihren gewünschten WLAN-Kanal aus",
  "wifi_channel_selection_dd_label_channel": "WLAN-Kanal",
  "wifi_spectrum_good_btn_manual": "Manuell",
  "wifi_spectrum_good_btn_ok": "OK",
  "wifi_spectrum_not_good_btn_fix": "FIX",
  "wifi_spectrum_btn_get_tip": "TIP",
  "wifi_spectrum_btn_get_tip_desc_ins_one": "Schalten Sie Ihren Router aus und starten Sie es erneut.",
  "wifi_spectrum_btn_get_tip_desc_ins_two": "Näher am Router ist das WLAN-Signal stärker.",
  "wifi_spectrum_btn_get_tip_desc_ins_three": "Hindernisse (z. B. Türen, Fenster, Wände, Möbel) zwischen Ihrem Router und Ihrem Mobiltelefon oder Tablet beeinflussen die Signalstärke.",
  "wifi_spectrum_btn_get_tip_desc_ins_four": "Wechseln Sie zu einem Kanal mit weniger Überlastung. Der beste Kanal kann sich im Laufe der Zeit ändern, daher sollten Sie den Kanal regelmäßig prüfen.",
  "wifi_channel_graph_header_5ghz": "5 GHz-Bereich",
  "device_status_online": "Online",
  "device_status_very_slow_res": "Dieses Gerät reagiert nicht",
  "device_status_connected_nw": "Mit Netzwerk verbunden",
  "device_status_connected_quality": "Verbindungsqualität ist unterdurchschnittlich",
  "device_status_unstable_connection": "Instabile Verbindung zum Gerät",
  "device_status_not_connected": "Derzeit nicht dem Netzwerk verbunden",
  "unknown_state": "Unbekannt",
  "local_network_details_status": "Status",
  "local_network_tap_to_change": "Ändern",
  "local_network_details_type": "Art",
  "local_network_tap_to_select": "Tippen Sie auf, um auszuwählen",
  "local_network_details_connection": "Verbindung",
  "local_network_details_last_seen": "Zuletzt gesehen",
  "local_network_details_monitor_device": "Benachrichtigungen",
  "monitor_device_on": "EIN",
  "monitor_device_off": "AUS",
  "local_network_details_ip": "IP Adresse",
  "local_network_details_manufacturer": "Hersteller",
  "id_foreground": "Vordergrund-App",
  "id_battery_level": "Batterie Level",
  "local_network_details_responsiveness": "Latenz",
  "device_details_conn_qual": "Verbindungsqualität",
  "device_details_cpu_usage": "CPU Auslastung",
  "device_details_internet_usage_time": "(diese Minute)",
  "id_speed_test": "Geschwindigkeitstest",
  "tap_entry": "Tippen Sie auf einen Eintrag, um Details anzuzeigen.",
  "local_network_no_devices_found": "Keine Geräte gefunden",
  "device_type_gateway": "Gateway",
  "device_type_access_point": "Access Point",
  "device_type_printer": "Drucker",
  "device_type_media_server": "Medienserver",
  "device_type_tv_receiver": "TV-Receiver",
  "device_type_gaming_console": "Spielekonsole",
  "device_type_mobile": "Mobiltelefon",
  "device_type_tablet": "Tablet",
  "device_type_laptop": "Laptop",
  "device_type_desktop": "Desktop",
  "lan_devices": "Geräte im  Netz",
  "device_details": "Details Gerät",
  "diagnose_btn": "DIAGNOSE",
  "str_assigned": "Zugewiesen",
  "str_waiting": "Anfragen",
  "str_signinto_agent_portal": "Anmeldung für das Support Portal",
  "str_password_required": "Passwort wird benötigt",
  "str_remember_me": "Speichern",
  "str_signin": "Anmelden",
  "str_cred_incorrect": "Benutzername/Passwort ungültig",
  "str_server_unavailble": "Server nicht erreichbar Bitte versuchen Sie es in einigen Minuten erneut.",
  "str_forgot_pwd": "Passwort vergessen?",
  "str_create_new_account": "Neues Konto erstellen",
  "str_enter_email_to_recover": "Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort wiederherzustellen.",
  "str_invalid_email": "Das ist keine gültige E-Mail",
  "str_reset_pwd": "Passwort zurücksetzen",
  "str_create_account": "Konto erstellen",
  "str_repeat_password": "Passwort muss zwei mal eingegeben werden.",
  "str_agree_with": "Ich stimme zu:",
  "str_terms_conditions": "Geschäftsbedingungen",
  "str_sign_up": "Registrieren",
  "str_have_account": "Konto besteht bereits?",
  "str_login": "Anmelden",
  "str_profile": "Profil",
  "str_first_name": "Vorname",
  "str_last_name": "Nachname",
  "str_mobile_number": "Handynummer",
  "str_lock": "Sperren",
  "str_logout": "Abmelden",
  "str_menu": "Menü",
  "str_dashboard": "Dashboard",
  "str_digital_support": "Support",
  "str_data_analytics": "Statistik",
  "str_marketing_engine": "Marketing-Engine",
  "str_devices": "Geräte",
  "str_support_cases": "Support-Fälle",
  "str_diagnostic_tests": "Tests",
  "str_users": "Benutzer",
  "str_sessions": "Sessions",
  "str_info_from_ndays": "Die angezeigten Informationen sind Daten der letzten 90 Tage.",
  "str_device_share": "Anteil",
  "str_support_center": "Hilfecenter",
  "str_search": "Suche",
  "str_wakedevice": "Gerät wecken",
  "str_device": "Gerät",
  "str_live_diagnostics_results": "Live-Diagnoseergebnisse",
  "str_provider": "Aktueller Anbieter",
  "str_publicip": "Öffentliche IP",
  "str_ticket": "Ticket",
  "str_status": "Status",
  "str_timeline_box": "Zeitleiste",
  "str_running_tests": "Tests in Bearbeitung...",
  "str_cancel": "ABBRECHEN",
  "str_wifi_configuration": "WLAN-Konfiguration",
  "str_custom_user_settings": "Benutzerdefinierte Einstellungen",
  "str_ida_host": "IDA-Server",
  "str_test_group": "Testgruppe",
  "str_test": "Test",
  "str_silently": "Hintergrund",
  "str_customer_details": "Kundendetails",
  "str_contract_plan": "Vertrag",
  "str_no_info_available": "Keine Information verfügbar",
  "str_model": "Modell",
  "str_device_offline": "Gerät ist offline",
  "str_no_av_device_pc": "Es wurde kein Video- / Audiogerät auf Ihrem PC gefunden",
  "str_check_av_input": "Bitte überprüfen Sie den Audio / Video-Eingang",
  "str_call_accept_by": "Anruf angenommen von",
  "str_agent_closes_call": "Der Support Agent hat aufgehängt",
  "str_incoming_call": "Eingehender Anruf",
  "str_call_cancel_timeout": "Anruf nach 30 Sekunden abgelehnt",
  "str_agent_cancel_call": "Der Support hat den Anruf abgebrochen",
  "str_in_video_call": "Videoanruf aufgebaut",
  "str_close": "Schließen",
  "str_connect": "Verbinden",
  "str_disconnect": "Trennen",
  "str_remote_timeout": "Anfrage läuft aus in: ",
  "str_canvas_not_supported": "Fernzugriff wird nicht unterstützt.",
  "str_input_mode": "Eingabemodus",
  "str_event_injection": "Event Injection",
  "str_screen_drawing": "Bildschirmzeichnung",
  "str_quick_access_screens": "Schnellzugriff",
  "str_settings": "Einstellungen",
  "str_security": "Sicherheit",
  "str_apps": "Apps",
  "str_status_notavailable": "Status nicht verfügbar",
  "router_dialog_username": "Nutzername",
  "router_dialog_validation_username_required": "Benutzername erforderlich",
  "trace_route_your_device_loc": "Das Gerät - {device_ip}",
  "trace_route_summary_multiple_slowest_hops": "Mehrere langsamste Hops mit {max_latency} ms an {hop_positions}",
  "trace_route_summary_single_slowest_hop": "Langsamster hop {max_latency} ms zwischen {hop1} und {hop2}",
  "trace_route_invisible_hop": "Anonymer Hop",
  "trace_route_map_gateway": "Gateway",
  "trace_route_list_distance": "für {distance} km",
  "test_result_header_mobile_network": "Mobilfunkverbindung",
  "test_result_header_device": "Gerät",
  "result_list_section_title_Problems": "Fehler",
  "result_list_history": "Verlauf",
  "no_history_found": "Keine Verlauf verfügbar",
  "result_list_section_title_Warnings": "Warnungen",
  "result_list_manual_test": "Manueller Test",
  "result_list_section_title_Warning": "Warnung",
  "NotAllowedError": "Diese Software konnte nicht auf Ihre Kamera / Ihr Mikrofon zugreifen. Bitte erlauben Sie den Zugriff, indem Sie auf das Video- / Audio-Symbol neben der Adressleiste klicken",
  "device_offline_status_connectionlost": "Kein Kontakt zum Empfänger. Überprüfen Sie den Gerätestatus und die Internetverbindung",
  "device_offline_status_logout": "Dieses Gerät scheint offline zu sein. Erst \"Wake-Up\" an Gerät senden.",
  "speed_test_distance_label": "Entfernung",
  "id_run_test": "Ausführen",
  "speed_test_tab_title": "Ergebnisse",
  "speed_test_title": "Speed Test",
  "wifi_channel_tab_graph": "Übersicht",
  "id_fix_failed_title": "Gescheitert",
  "wifi_manual_switch_title": "Wählen Sie einen WLAN-Kanal aus",
  "wifi_channel_selection_dd_label_band": "WLAN-Geschwindigkeit",
  "wifi_spectrum_btn_switch_to_other_channel": "Manuell",
  "wifi_spectrum_not_good_btn_manual": "Manuell",
  "wifi_spectrum_btn_get_tip_desc_header": "Hier finden Sie weitere Ratschläge für ein gutes WLAN-Signal:",
  "wifi_channel_graph_header_24ghz": "2,4 GHz-Bereich",
  "device_status_slow_res": "Dieses Gerät reagiert langsam",
  "device_status_offline": "Offline",
  "local_network_details_device_name": "Gerätename",
  "local_network_details_mac": "MAC-Adresse",
  "device_details_model": "Modell",
  "device_details_internet_usage": "Internetnutzung",
  "id_speed_test_p2p_desc": "Führen Sie auf diesem Gerät einen Geschwindigkeitstest durch",
  "device_type_computer": "Computer",
  "device_type_phone": "Telefon",
  "str_supportqueue_is_empty": "Support-Warteschlange ist leer",
  "str_username_is_required": "Ein Benutzername ist erforderlich",
  "str_email_required": "E-Mail ist erforderlich",
  "str_backto_login": "Zurück zur Anmeldung",
  "str_user_email_already_registered": "Benutzername und / oder E-Mail sind bereits registriert",
  "str_enter_pwd_to_unlock": "Bitte geben Sie Ihr Passwort ein, um den Bildschirm zu entsperren!",
  "str_sign_other_account": "Benutzername/Passwort falsch",
  "str_email": "Email",
  "str_registered_users": "Registrierte User",
  "str_usage_activity": "Nutzungsaktivität",
  "str_create_user": "Neues Konto erstellen",
  "str_new_ticket": "Neues Ticket",
  "str_speedtest_header": "Auf diesem Gerät einen Internet-Geschwindigkeitstest ausführen",
  "str_run": "Asuführen",
  "str_ringing": "Klingelt...",
  "str_call_accepted": "Anruf angenommen",
  "str_battery": "Batterie",
  "router_dialog_content": "Bitte geben Sie das Router-Passwort ein, um die Diagnose zu starten:",
  "router_dialog_pwd": "Passwort",
  "router_dialog_validation_pwd_required": "Passwort erforderlich",
  "cancel_btn":"ABBRECHEN",
  "main_wifi_router_short":"*Router",
  "main_fixed_line_short":"*Fixed line",
  "main_wifi_network_short":"*WiFi",
  "str_agent_feedback":"*Support Agent Feedback",
  "str_thank_feedback":"*Thank you for your feedback. It will help us to improve the agent.",
  "str_feedback_user_complaint":"*What did the user complain about?",
  "str_feedback_complaint_slow":"*Internet too slow",
  "str_feedback_complaint_not_work":"*Internet not working",
  "str_feedback_complaint_trouble":"*Device making trouble",
  "str_other":"*Other",
  "str_feedback_problem_identify":"*Could you identify the root cause of the problem?",
  "str_feedback_problem_cause":"*If yes, What was the cause?",
  "str_feedback_problem_solve":"*Could you solve the problem?",
  "str_yes":"*Yes",
  "str_no":"*NO",
  "str_feedback_app_helpful":"*Was the mobile app helpful in solving the problem?",
  "str_feedback_total_helpful":"*totall not helpful",
  "str_feedback_vhelpful":"*very helpful",
  "str_feedback_customer_satisfaction":"*How happy was the customer with the solution? ",
  "str_feedback_not_happy":"*totall not happy",
  "str_feedback_vhappy":"*very happy",
  "str_submit":"*SUBMIT",
  "str_skipform":"*Skip form",
  "str_close_ticket":"*Close Ticket",
  "str_speedtest_fail_status":"*Speed test request has been failed due to following error:",
  "str_try_again":"*Please try again",
  "str_speedtest_error_msg":"*The request timed out. Please check whether the device is online.",
  "str_remote_fail_status":"*Remote session has been failed due to following error:",
  "str_videocall_fail_status":"*Video calling has been failed",
  "str_remote_running_status":"*Remote session has been running with",
  "str_remote_restart_msg":"*Please disconnect and proceed",
  "str_session_expired":"*Your session has expired",
  "str_plz_login":"*Please login again.",
  "str_continue":"*Continue",
  "str_no_open_conversation":"*User does not have any open conversations",
  "str_want_2_create_ticket":"*Do you want to create a new one?",
  "str_connecting_server":"*Connecting to server..",
  "speed_test_data_consumption_warning":"*Running a speed test requires sending and receiving data and is best done on connections with no usage limit. It is advised to refrain from testing on mobile data connections.",
  get_logs_btn:"*GET LOGS",
  str_send:"*Send",
  str_request_access:"*Request access",
  str_issues_found:"*Issues found"
 }
};
